module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-chesnut-006-1200x2490.1b6be693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-chesnut-006-1200x2490.jpg
// module id = 1090
// module chunks = 37